// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "कम्पलीशन स्कोर",
            learn_more_text: "अधिक जानिए",
            info_btn_details: {
              video_url: undefined,
              question: "कम्पलीशन स्कोर क्या है?",
              answer: "कम्पलीशन स्कोर की गणना आपको दिये गए पिछले 50 ऑर्डरों में से पूरे किए गए कुल ऑर्डर के रूप में की जाती है।\n        \n उदहारण: यदि पोर्टर 50 ऑर्डर देता है और उसमें  से आप 40 पूरे करते हैं, तो कम्पलीशन स्कोर 80% है।"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "कम्पलीशन स्कोर क्या है और यह महत्वपूर्ण क्यों है?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "मैं अपना कम्पलीशन स्कोर कैसे बड़ा सकता हूँ?",
                answer: "अच्छा कम्पलीशन स्कोर बनाए रखने के लिए सभी ऑर्डर स्वीकार करें और पूरा करें"
              },
              {
                video_url: undefined,
                question: "एक अच्छा कम्पलीशन स्कोर कितना होगा?",
                answer: "सबसे अधिक कमाई करने वाले पोर्टर पार्टनर 90% या उससे ज्यादा का कम्पलीशन स्कोर बनाए रखते हैं।"
              },
              {
                video_url: undefined,
                question: "मैं अपना कम्पलीशन स्कोर क्यों नहीं देख पा रहा हूँ?",
                answer: "स्कोर की गणना केवल उन पार्टनर के लिए की जाती है जिन्हें कम से कम 50 ऑर्डर प्राप्त हुए हों।"
              }
            ],
            locked_score_msg: "स्कोर अनलॉक करने के लिए अधिक आर्डर स्वीकार करें",
            message_text: "पार्टनर्स जिनका कम्पलीशन स्कोर ज्यादा होता है उन्हें ज्यादा आर्डर मिलने की संभावना अधिक होती है।"
          };
  } else {
    return {
            title_text: "कम्पलीशन स्कोर",
            learn_more_text: "अधिक जानिए",
            info_btn_details: {
              video_url: undefined,
              question: "कम्पलीशन स्कोर क्या है?",
              answer: "कम्पलीशन स्कोर की गणना आपको दिये गए पिछले 50 ऑर्डरों में से पूरे किए गए कुल ऑर्डर से की जाती है। ऐसे ऑर्डर्स जो आपसे पहले दूसरे पार्टनर ने एक्सेप्ट कर लिए उसे इस स्कोर में शामिल नहीं किया जाएगा। \n\n                    उदहारण: यदि पोर्टर 50 ऑर्डर देता है और उसमें  से आप 40 पूरे करते हैं, तो कम्पलीशन स्कोर 80% है।"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "कम्पलीशन स्कोर क्या है और यह महत्वपूर्ण क्यों है?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "मैं अपना कम्पलीशन स्कोर कैसे बड़ा सकता हूँ?",
                answer: "अच्छा कम्पलीशन स्कोर बनाए रखने के लिए सभी ऑर्डर स्वीकार करें और पूरा करें"
              },
              {
                video_url: undefined,
                question: "एक अच्छा कम्पलीशन स्कोर कितना होगा?",
                answer: "सबसे अधिक कमाई करने वाले पोर्टर पार्टनर 90% या उससे ज्यादा का कम्पलीशन स्कोर बनाए रखते हैं।"
              },
              {
                video_url: undefined,
                question: "मैं अपना कम्पलीशन स्कोर क्यों नहीं देख पा रहा हूँ?",
                answer: "स्कोर की गणना केवल उन पार्टनर के लिए की जाती है जिन्हें कम से कम 50 ऑर्डर प्राप्त हुए हों।"
              }
            ],
            locked_score_msg: "स्कोर अनलॉक करने के लिए अधिक आर्डर स्वीकार करें",
            message_text: "पार्टनर्स जिनका कम्पलीशन स्कोर ज्यादा होता है उन्हें ज्यादा आर्डर मिलने की संभावना अधिक होती है।"
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
